import { useEffect, useState } from 'react';
import { useI18n } from '../i18n/I18nProvider';
import StudioIcon from './StudioIcon';

export default function GenerationStatus({ mediaType = 'image' }) {
  const { t } = useI18n();
  const [startedAt] = useState(() => Date.now());
  const [elapsed, setElapsed] = useState(0);

  useEffect(() => {
    const timer = setInterval(() => setElapsed(Math.floor((Date.now() - startedAt) / 1000)), 1000);
    return () => clearInterval(timer);
  }, [startedAt]);

  const type = ['image', 'video', 'audio', 'text'].includes(mediaType) ? mediaType : 'image';
  const longWait = elapsed >= (type === 'video' ? 90 : 45);
  const elapsedLabel = `${Math.floor(elapsed / 60)}:${String(elapsed % 60).padStart(2, '0')}`;

  return (
    <div className="GenerationStatus">
      <div className={`GenerationArtwork GenerationArtwork--${type}`} aria-hidden="true">
        <div className="GenerationOrbit" />
        <div className="GenerationTile GenerationTile--back" />
        <div className="GenerationTile GenerationTile--front"><StudioIcon name={type} size={34} /><span /><span /></div>
        <span className="GenerationSpark"><StudioIcon size={18} /></span>
      </div>
      <div className="GenerationCopy" role="status" aria-live="polite" aria-atomic="true">
        <p className="GenerationEyebrow">{t('generation.eyebrow')}</p>
        <h2>{t(`generation.${type}`)}</h2>
        <p className="GenerationHint">{longWait ? t('generation.longWait') : t(`generation.${type}Hint`)}</p>
      </div>
      <div className="GenerationTrack" aria-hidden="true"><span /></div>
      <div className="GenerationMeta">
        <span><i aria-hidden="true" />{t('generation.inProgress')}</span>
        <span className="GenerationElapsed" aria-label={t('generation.elapsed', { time: elapsedLabel })} dir="ltr">{elapsedLabel}</span>
      </div>
      <p className="GenerationFootnote">{t('generation.keepOpen')}</p>
    </div>
  );
}
